import React from "react";
import Sidebar from "../../components/Sidebar/Sidebar";
import "./Documentation.css";

function DocumentationPage() {
    return (
        <div className="app-container">
            <Sidebar />
            <main className="main-content">
                <h1 className="main-title">Documentation Page</h1>
                <p className="main-description">Welcome to the Documentation page!</p>
            </main>
        </div>
    );
}

export default DocumentationPage;